import { render, staticRenderFns } from "./SmallGauge.vue?vue&type=template&id=41e65f8a&scoped=true"
import script from "./SmallGauge.vue?vue&type=script&lang=js"
export * from "./SmallGauge.vue?vue&type=script&lang=js"
import style0 from "./SmallGauge.vue?vue&type=style&index=0&id=41e65f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e65f8a",
  null
  
)

export default component.exports